var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        position: "fixed",
        top: "0",
        bottom: "0",
        width: "100%",
        "z-index": "3"
      }
    },
    [
      _c(
        "div",
        { staticClass: "main-cnt block-image ex-preprocessing" },
        [
          _c("slider-pre", {
            attrs: { files: _vm.files },
            on: {
              remove: function($event) {
                return _vm.removeFile($event)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "footer-img" }, [
            _c(
              "div",
              {
                staticClass: "lst-opts w-100",
                class: { "is-disabled": _vm.isUpdate }
              },
              [
                _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c("div", { staticClass: "fs-18" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("voucher.ocr.process_ocr")) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lst-type w-12rem" }, [
                    _c(
                      "ul",
                      { staticClass: "row no-gutters" },
                      _vm._l(_vm.ocrList, function(s) {
                        return _c(
                          "li",
                          {
                            key: s.id,
                            staticClass: "col",
                            attrs: { value: s.id },
                            on: {
                              click: function($event) {
                                !_vm.isUpdate && _vm.selectOcr(s.id)
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass: "type-txt",
                              class: {
                                active: _vm.selectedOcr == s.id,
                                noOcr: _vm.isUpdate || !_vm.ocr,
                                "no-active": _vm.selectedOcr != s.id
                              },
                              attrs: {
                                disabled: _vm.isUpdate || !_vm.isCanOcr()
                              },
                              domProps: { innerHTML: _vm._s(s.name) }
                            })
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2 mb-2" }),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c("div", { staticClass: "fs-18" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("voucher.ocr.handwriting")) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pl-2" }, [
                    _c("label", { staticClass: "switch" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.handwriteOcr,
                            expression: "handwriteOcr"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          disabled: _vm.isUpdate || !_vm.ocr
                        },
                        domProps: {
                          checked: Array.isArray(_vm.handwriteOcr)
                            ? _vm._i(_vm.handwriteOcr, null) > -1
                            : _vm.handwriteOcr
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.handwriteOcr,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.handwriteOcr = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.handwriteOcr = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.handwriteOcr = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "slider round" })
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.files.length < 10,
                  expression: "files.length < 10"
                }
              ],
              staticClass: "btn btn-add-file"
            },
            [
              _c("input", {
                staticClass: "d-none",
                attrs: {
                  type: "file",
                  name: "",
                  multiple: "",
                  accept:
                    "image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n             application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"
                },
                on: { change: _vm.preprocessUpload }
              }),
              _vm._v(" "),
              _c("i", { staticClass: "icon-camera-plus" })
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17516b0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17516b0d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Voucher/CameraPreProcessing.vue
// module id = null
// module chunks = 